<ul class="menu">
    <li>
      <ng-container *ngFor="let notification of notifications">
        <a (click)="goto(notification)"  href="#" onclick="return false;">
          <!-- <span class="table-img msg-user">
            <img src="{{notification.userImg}}" alt="">
          </span> -->
          <span class="menu-info">
            <span class="menu-title">{{notification.title}}</span>
            <span class="menu-desc"><i class="material-icons">access_time</i> {{notification.sentTime | date:'dd.MM.yyyy HH:mm'}}</span>
            <span class="menu-desc">{{notification.message}}</span>
          </span>
        </a>
      </ng-container>
    </li>
  </ul>